import types from './types';
import { RESET_DETAILS } from '../genericDetails/types';
import { Mode } from '../../constants';

const defaultState = {
  inventory: null,
  initialData: {},
  isLoading: false,
  markAsChecked: false,
  nonCheckedChemicals: {
    personal: 0,
    dso: 0,
    tso: 0,
  },
  checked: false,
};

const updateInitialData = (state, params) => {
  let { initialData } = state;
  initialData.inventory = params.inventory;
  let { chemicalProduct } = initialData.inventory;
  chemicalProduct.selectedChemicalProduct.id = chemicalProduct.id;
  return initialData;
};

const getNewInventoryFromCurrent = (inventory, initialData) => {
  let newInventory = Object.assign({}, inventory);

  //set new id from sequence, else will be done on initial data success
  if (initialData && initialData.inventory && initialData.inventory.id)
    newInventory.id = initialData.inventory.id;
  else newInventory.id = null;

  newInventory.files = [];
  newInventory.contacts.forEach(f => (f.id = null));
  newInventory.updateUser = null;
  newInventory.updateDte = null;
  newInventory.createUser = null;
  newInventory.createDte = null;
  newInventory.checkUser = null;
  newInventory.checkDte = null;
  newInventory.checkCseUser = null;
  newInventory.checkCseDte = null;
  newInventory.checkCseComments = null;

  if (newInventory.envAttributes) newInventory.envAttributes.id = null;
  if (newInventory.chemicalRiskAttributes) {
    newInventory.chemicalRiskAttributes.id = null;
    newInventory.chemicalRiskAttributes.checkCseDte = null;
    newInventory.chemicalRiskAttributes.checkCseUser = null;

    if (newInventory.chemicalRiskAttributes.exposedPersons)
      newInventory.chemicalRiskAttributes.exposedPersons.forEach(f => (f.id = null));
    if (newInventory.chemicalRiskAttributes.edmsNumbersExposureMonitoring)
      newInventory.chemicalRiskAttributes.edmsNumbersExposureMonitoring.forEach(f => (f.id = null));
  }
  console.log(newInventory); //todo check by hse
  return newInventory;
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_INVENTORY_INITIAL_DATA:
      return { ...state, inventory: null, initialData: {}, isLoading: true };
    case types.GET_INVENTORY_INITIAL_DATA_SUCCESS:
      let inventory;
      //set new id from sequence for cloning, else will be done on get inventory success
      if (request.params && request.params.isCloneMode)
        inventory = state.inventory
          ? { ...state.inventory, id: data.inventory.id }
          : state.inventory;
      else inventory = data.inventory ? data.inventory : state.inventory;
      return { ...state, inventory: inventory, initialData: data, isLoading: false };
    case types.GET_INVENTORY_INITIAL_DATA_FAILURE:
      return { ...state, isLoading: false };

    case types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL:
      return { ...state, isLoading: true };
    case types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      if (data.openConfirmationModal) return { ...state, isLoading: false };
      else
        return {
          ...state,
          inventory: data.inventory,
          initialData:
            request.params.mode == Mode.EDIT ? updateInitialData(state, data) : state.initialData,
          isLoading: false,
          inventorySave: state.inventorySave != null ? state.inventorySave + 1 : 1,
          idsDeletePreciseLocationBatch: data.idsDeletePreciseLocationBatch,
          markAsChecked: false
        };
    case types.SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_FAILURE:
      return { ...state, isLoading: false, markAsChecked: false };

    case types.GET_INVENTORY:
    case types.GET_DELETED_INVENTORY:
      return { ...state, isLoading: true };
    case types.GET_INVENTORY_SUCCESS:
    case types.GET_DELETED_INVENTORY_SUCCESS:
      if (request.params && request.params.isCloneMode)
        data = getNewInventoryFromCurrent(data, state.initialData);
      return { ...state, inventory: data, initialInventory: data, isLoading: false };
    case types.GET_INVENTORY_FAILURE:
    case types.GET_DELETED_INVENTORY_FAILURE:
      return { ...state, isLoading: false };

    case types.GET_INVENTORY_TITLE_DETAILS:
      return { ...state, isLoading: true };
    case types.GET_INVENTORY_TITLE_DETAILS_SUCCESS:
      return { ...state, inventoryTitleDetails: data, isLoading: false };
    case types.GET_INVENTORY_TITLE_DETAILS_FAILURE:
      return { ...state, isLoading: false };

    case types.DELETE_INVENTORY:
      return { ...state, isLoading: true };
    case types.DELETE_INVENTORY_SUCCESS:
    case types.DELETE_INVENTORY_FAILURE:
      return { ...state, isLoading: false };

    case types.IS_PRECISE_LOCATION_SET:
      return { ...state };
    case types.IS_PRECISE_LOCATION_SET_SUCCESS:
      return { ...state, isPreciseLocationSet: data };
    case types.IS_PRECISE_LOCATION_SET_FAILURE:
      return { ...state };

    case types.GET_NON_CHECKED_CHEMICALS:
      return { ...state };
    case types.GET_NON_CHECKED_CHEMICALS_SUCCESS:
      return { ...state, nonCheckedChemicals: data };
    case types.GET_NON_CHECKED_CHEMICALS_FAILURE:
      return { ...state };

    case types.MARK_AS_CHECKED:
      return { ...state, checked: false, isLoading: true };
    case types.MARK_AS_CHECKED_SUCCESS:
      return { ...state, checked: true, isLoading: false };
    case types.MARK_AS_CHECKED_FAILURE:
      return { ...state, checked: false, isLoading: false };

    case types.CREATE_INVENTORIES_QR_STICKERS_PDF:
      return { ...state };
    case types.CREATE_INVENTORIES_QR_STICKERS_PDF_SUCCESS:
      return { ...state };
    case types.CREATE_INVENTORIES_QR_STICKERS_PDF_FAILURE:
      return { ...state };

    case RESET_DETAILS:
      return { ...defaultState };

    default:
      return state;
  }
};
